export default __webpack_public_path__ + "static/media/Fitness Center- Dumbbells.d58bd3ae.jpg";